import React, { useCallback, useState } from "react";
import OAuthCardLayout from "./OAuthCardLayout";
import { Button, FormGroup, Input, Row } from "reactstrap";
import { Form } from "react-bootstrap";
import SikkaInput from "../../common/SikkaInput";
import { useForm } from "react-hook-form";
import ReactInputMask from "react-input-mask";
import classNames from "classnames";
import NewPasswordLayout from "./NewPasswordLayout";
import withRedirect from "../../../hoc/withRedirect";

const ForgotPassword = ({ setRedirect, setRedirectUrl }) => {
  const { register, handleSubmit, errors, watch } = useForm();

  const [step, setStep] = useState(1);

  const onSubmit = useCallback((data) => {
    switch (step) {
      case 1:
        break;
      case 2:
        break;
    }
    setStep(step + 1);
  });

  return (
    <div>
      <OAuthCardLayout lg={4}>
        {step < 3 && (
          <Row className="d-flex flex-column flex-center w-100">
            <p className="fs-2 font-weight-bold text-black py-3">Verify Email</p>
            <Form onSubmit={handleSubmit((data) => onSubmit(data))} className="d-flex w-100 flex-center flex-column">
              <FormGroup className="w-100">
                <SikkaInput
                  label={false}
                  placeholder="Email"
                  id="email"
                  name="email"
                  innerRef={register({
                    required: "Email is required",
                    pattern: {
                      value: /[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})/i,
                      message: "Email must be valid",
                    },
                  })}
                  onFocus={() => {
                    setStep(1);
                  }}
                  errors={errors}
                  className="fs-0"
                />
              </FormGroup>
              {step === 2 && (
                <FormGroup className="w-100">
                  <SikkaInput
                    placeholder="Verification Code"
                    id="vcode"
                    name="vcode"
                    innerRef={register({
                      required: "Verification code is required",
                    })}
                    errors={errors}
                    className="fs-0"
                  />
                </FormGroup>
              )}
              <Row className="col-10 justify-content-evenly">
                {step === 2 && (
                  <FormGroup>
                    <Button color="primary" name="validate" className="pl-pr-2 fs--1 btn-primary">
                      Resend
                    </Button>
                  </FormGroup>
                )}
                <FormGroup>
                  <Button color="primary" type="submit" name="validate" className="pl-pr-2 fs--1 btn-primary">
                    {step === 1 ? "Send Verification Code" : "Submit"}
                  </Button>
                </FormGroup>
              </Row>
            </Form>
          </Row>
        )}
        {step === 3 && (
          <NewPasswordLayout
            onBackPressed={() => {
              setStep(1);
            }}
          />
        )}
      </OAuthCardLayout>
    </div>
  );
};

export default withRedirect(ForgotPassword);
